import React from 'react';
import { IconNumberOne, IconNumberThree, IconNumberTwo } from '@paretogroup/tess';
import { ColorConstants } from '@shared/constants';
import { STATIC_PATH } from '../../../../shared/constants/ImageConstants';

export const RANK = [
    `${STATIC_PATH}/rank/1.png`,
    `${STATIC_PATH}/rank/2.png`,
    `${STATIC_PATH}/rank/3.png`,
];

const ICON_SIZE = 14;

export const ICON = [
    <IconNumberOne size={ICON_SIZE} primaryColor={ColorConstants['regal-blue-50%']} secondaryColor={ColorConstants.white} />,
    <IconNumberTwo size={ICON_SIZE} primaryColor={ColorConstants['regal-blue-50%']} secondaryColor={ColorConstants.white} />,
    <IconNumberThree size={ICON_SIZE} primaryColor={ColorConstants['regal-blue-50%']} secondaryColor={ColorConstants.white} />,
];
